import React, { useEffect, useState } from 'react'
import Routes from './component/Routes';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import './css/style.css'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Notification from './component/Notification';

function App() {
  const [showInstall, setShowInstall] = useState(false)
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      if (isMobile) {
        setShowInstall(true);
        setDeferredPrompt(e);
      }
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () =>
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
  }, []);

  const handleInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
    }
  };

  const closeModal = () => {
    setShowInstall(false)
  };
  return (
    <div className="App">
      {showInstall && (
      <div
      style={{
        position: "fixed",
        alignSelf:'center',
        flex:1,
        // top: 0,
        // left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px 30px",
          borderRadius: "8px",
          textAlign: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          maxWidth: "300px",
          width: "80%",
        }}
      >
        <h4 style={{ marginBottom: "10px" }}>Install App</h4>
        <p style={{ marginBottom: "20px" }}>
          Do you want to install this app on your device?
        </p>
        <div>
          <button
            onClick={handleInstall}
            style={{
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              padding: "10px 20px",
              borderRadius: "4px",
              cursor: "pointer",
              marginRight: "10px",
            }}
          >
            Install
          </button>
          <button
            onClick={closeModal}
            style={{
              backgroundColor: "#ccc",
              color: "#000",
              border: "none",
              padding: "10px 20px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
      )}
      <Routes />
      <ToastContainer
        position="top-right"
        autoClose={10000}
        theme="colored"
      />
      <Notification />
    </div>
  );
}

export default App;
